export const closestParkingsInfoSelector = ({closestParkingsInfo}) => closestParkingsInfo